import { useSnackbar } from './useSnackbar'

const withHookSnackbar = (WrappedComponent) => {
  return function WithHookComponent(props) {
    const { displaySnackbar } = useSnackbar()

    return <WrappedComponent {...props} displaySnackbar={displaySnackbar} />
  }
}

export default withHookSnackbar
